module.exports = __webpack_public_path__ + "static/media/bathroom.3243e3cb.png";